import { Box } from '@mui/system';
import { Rating, ReadMore } from '@care/react-component-lib';
import { Card, CardContent, Typography } from '@mui/material';
import {
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview as LatestReview,
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview_reviewer as Reviewer,
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver_member as Member,
} from '@/__generated__/getSearchResults';

type ReviewsCardProps = {
  revieweeName: Member['displayName'];
  reviewerName: Reviewer['displayName'];
  comment: LatestReview['comment'];
  rating: LatestReview['rating'];
};

export const ReviewsCard = ({ revieweeName, comment, rating, reviewerName }: ReviewsCardProps) => {
  const reviewSummary = `Review for ${revieweeName} by ${reviewerName}`;

  return (
    <Card
      sx={{
        boxShadow: '0 0 16px rgba(0, 0, 0, 0.15)',
        border: 'none',
      }}>
      <CardContent>
        <Rating defaultValue={rating} readOnly sx={{ mb: 2 }} />
        <Box mb={2}>
          <ReadMore
            component="div"
            showLessLabel="read less"
            showMoreLabel="read more"
            charLimit={140}
            value={comment}
            variant="body2"
          />
        </Box>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {reviewSummary}
        </Typography>
      </CardContent>
    </Card>
  );
};
